import React from 'react';
import { Button, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle } from '@mui/material';

interface UnshareTemplateDialogProps {
    open: boolean;
    onClose: () => void;
    onConfirm: () => void;
    templateName: string | undefined;
}

const UnshareTemplateDialog: React.FC<UnshareTemplateDialogProps> = ({ open, onClose, onConfirm, templateName }) => {
    return (
        <Dialog
            open={open}
            onClose={onClose}
            aria-labelledby="unshare-dialog-title"
            aria-describedby="unshare-dialog-description"
        >
            <DialogTitle id="unshare-dialog-title">Delen Stoppen?</DialogTitle>
            <DialogContent>
                <DialogContentText id="unshare-dialog-description">
                    Weet je zeker dat je wilt stoppen met het delen van de template "{templateName}" met de organisatie?
                    Andere gebruikers binnen de organisatie hebben hierna geen toegang meer.
                </DialogContentText>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose}>Annuleren</Button>
                <Button
                    onClick={() => {
                        onConfirm();
                        onClose(); // Close dialog after confirmation
                    }}
                    color="warning" // Use warning color for potentially destructive action
                    autoFocus
                >
                    Delen Stoppen
                </Button>
            </DialogActions>
        </Dialog>
    );
};

export default UnshareTemplateDialog;
